import { View } from "@-/com.npmjs.react-native";
import { FrostedSurface } from "@-/dev.improve.haniverse.components.ui.frosted-surface";
import { Icon } from "@-/dev.improve.haniverse.components.ui.icon";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { useBrowseTabsContentBottomInset } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._lib.content-bottom-inset";

/**
 * Frosts the list viewport below the material tabs and behind the native tabs. The sharp notice is
 * centred above the native tab capsule; the entire overlay lets scrolling pass through.
 */
export function BrowseLevelsComingSoonCurriculumNotice({ label }: { label: string }) {
  const bottomInset = useBrowseTabsContentBottomInset();
  return (
    <FrostedSurface
      className="absolute inset-0 items-center justify-center px-8"
      intensity={40}
      pointerEvents="none"
      style={{ paddingBottom: bottomInset }}
    >
      <View
        accessibilityLabel={`${label} Coming Soon`}
        accessibilityRole="text"
        accessible
        className="max-w-80 items-center gap-3"
        testID="browse-levels-coming-soon-notice"
      >
        <View className="size-11 items-center justify-center rounded-full bg-primary/10">
          <Icon className="text-primary" name="MdSchedule" size={22} />
        </View>
        <View className="items-center gap-0.5">
          <Text className="text-center text-base font-semibold text-foreground">{label}</Text>
          <Text className="text-center text-sm text-muted-foreground">Coming Soon</Text>
        </View>
      </View>
    </FrostedSurface>
  );
}
